// calling both current and archived teacher
export const START_FETCH_TEACHER = 'START_FETCH_TEACHER'
export const FAILED_FETCH_TEACHER = 'FAILED_FETCH_TEACHER'
export const SUCCESS_FETCH_TEACHER = 'SUCCESS_FETCH_TEACHER'

import getCurrentTeachers from 'controllers/teacher/getCurrentTeacher'
import getArchivedTeachers from 'controllers/teacher/getArchivedTeacher'
export const DEFAULT_PAGINATION = {
  activePage: 1,
  itemsCountPerPage: 25,
  totalItemsCount: 0,
}

export function fetchTeacher(opts, state){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_TEACHER,
      payload: {
        fetching: true,
        teacherState: state,
      }
    })

    const controllerFunction = state == 'current' ? getCurrentTeachers : getArchivedTeachers


    controllerFunction(opts)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_TEACHER,
        payload: {...result, fetching: false, hasPermission: true}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_TEACHER,
        payload: {err, hasPermission: false, fetching: false}
      })
    })
  }
}


const initState = {
  list: [],
  pagination: DEFAULT_PAGINATION,
}

export default function teacherList(state = initState, action){
  switch(action.type){
    case START_FETCH_TEACHER: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_TEACHER: {
      const {list, count, fetching, hasPermission, school_has_teacher} = action.payload
      return {
        ...state,
        list,
        count,
        fetching,
        hasPermission,
        school_has_teacher,
        pagination: {
          itemsCountPerPage: action.payload.amount_per_page,
          activePage: action.payload.current_page_number,
          totalItemsCount: action.payload.total_amount,
        }
      }
    }
    case FAILED_FETCH_TEACHER: {
      const {err, hasPermission, fetching} = action.payload
      return {...state, err, hasPermission, fetching}
    }

    default: return {...state}
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/ducks.js